<template lang="html">
  <div class="draft-picks">
    <header>
      <div v-if="!fullScreen" class="admin" @click="openAdmin">
        <i class="fas fa-list-ul" />
      </div>

      <h4>{{ draft.name }}</h4>
    </header>

    <section ref="pickList" class="picks-list">
      <div v-for="(pick, i) in localPicks" :key="i">
        <div class="round" v-if="i % draft.teams.length === 0">
          ROUND {{ Math.ceil((i + 1) / draft.teams.length) }}
        </div>

        <div :class="['pick', { current: currentPick === i + 1, 'has-player': pick.player }]">
          <div class="pick-number">{{ i + 1 }}</div>

          <div class="pick-details">
            <div class="pick-player" v-if="pick.player">
              {{ pick.player.name }} <span class="keeper-status" v-if="pick.keeper">K</span>
            </div>

            <div class="pick-team">
              {{ pick.team }}
            </div>
          </div>

          <div class="pick-player-team" v-if="pick.player">
            {{ pick.player.team }}
          </div>

          <div class="pick-position" v-if="pick.player">
            {{ pick.player.position }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      localPicks: [],
    };
  },

  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
      fullScreen: ({ draft }) => draft.fullScreen,
      currentPick: ({ draft }) => draft.draft.currentPick,
    }),

    ...mapGetters({
      picks: 'draft/picks',
    }),
  },

  mounted() {
    this.reset();
    this.setLocalPicks();
  },

  watch: {
    currentPick() {
      this.reset();
    },

    picks: {
      handler() {
        // Give the pick is in modal time before revealing here
        setTimeout(() => {
          this.setLocalPicks();
        }, 3000);
      },
      deep: true,
    },
  },

  methods: {
    openAdmin() {
      this.$store.commit('draft/SET_ADMIN_OPEN', true);
    },

    reset() {
      this.$nextTick(() => {
        const currentPickElement = document.querySelector('.pick.current');

        if (currentPickElement) {
          const height = this.$refs.pickList.offsetHeight / 2;
          const top = currentPickElement.offsetTop - height;

          this.$SmoothScroll(top, 500, undefined, this.$refs.pickList);
        }
      });
    },

    setLocalPicks() {
      this.localPicks = this.picks;
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-picks {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  header {
    display: flex;
    align-items: center;
    padding: $gp;
    background-color: $gray-color;
    color: $black-color;
    box-shadow: $bottom-shadow;
    z-index: 1;

    h4 {
      margin: 0;
    }

    .admin {
      font-size: px-to-rem(18px);
      margin-right: $gp;
    }
  }

  .picks-list {
    flex: 1;
    overflow-y: auto;
    margin-right: -$gp / 2;
  }

  .pick,
  .round {
    display: flex;
    padding: 0 $gp;
    align-items: center;
    font-size: px-to-rem(20px);
  }

  .pick {
    border-bottom: 2px solid $dark-color-active;
  }

  .round {
    background-color: $black-color;
    color: $white-color;
    height: px-to-rem(36px);
    line-height: px-to-rem(36px);
    font-size: px-to-rem(16px);
  }

  .pick {
    @include transition(background-color, color);

    background-color: $dark-color;
    color: $gray-color;
    height: px-to-rem(80px);

    .pick-team {
      @include transition(font-size);

      color: $gray-color;
      font-size: px-to-rem(22px);
    }

    &.current {
      color: $white-color;
      background-color: $primary-color;

      .pick-team {
        color: $white-color;
        font-size: px-to-rem(20px);
      }

      .pick-number {
        color: $white-color;
      }
    }

    &.has-player {
      color: $gray-color-lighter;

      .pick-team {
        font-size: px-to-rem(16px);
      }
    }
  }

  .pick-number {
    width: px-to-rem(48px);
    font-weight: bold;
  }

  .pick-details {
    flex: 1;
  }

  .pick-player {
    font-size: px-to-rem(20px);
    margin-bottom: $gp / 4;
  }

  .pick-player-team,
  .pick-position {
    font-size: px-to-rem(16px);
    opacity: 0.7;
    width: px-to-rem(40px);
    text-align: right;
  }
</style>
